import { BlocksIconChevronUp } from 'blocks-nextjs/blocks-web-components/components/icon/icons/chevron-up';
import React from 'react';
import { createComponent } from '../../CustomWrapper/CustomWrapper';

export const CatIconChevronUp = createComponent({ react: React, tagName: 'cat-icon-chevron-up', elementClass: BlocksIconChevronUp });
